(function () {
  function reinitReviewsIoRatingSnippets() {
    if (typeof reinitialiseRatingSnippet === 'function') {
      reinitialiseRatingSnippet();
    }
  }

  function scheduleReinit() {
    window.requestAnimationFrame(function () {
      window.setTimeout(reinitReviewsIoRatingSnippets, 0);
    });
  }

  ['recommendations:loaded', 'recentlyViewed:loaded', 'theme:section:load'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleReinit);
  });
})();
